import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { UserActionFeatureSystemsComponent } from '../userAction-featureSystem/userAction-featureSystem.component';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { ValidFeatureService } from '../../../../Services/validFeature.service';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { UserActionBaseComponent } from '../userAction-base.component';

@Component({
    selector: 'userAction-CreateVariants',
    templateUrl: 'userAction-createVariantsFeatureSystem.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionCreateVariantsFeatureSystemComponent) }
    ],
    standalone: false
})
export class UserActionCreateVariantsFeatureSystemComponent extends UserActionFeatureSystemsComponent {
  mode = false;
  createTechnicalDetails = false;

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    validFeatureService: ValidFeatureService
  ) {
    super(loginService,macroService,catalogService, validFeatureService);
  }

  createParameterStringAsJsonString(): string {
    let parameterJsonString = JSON.stringify({
      mode: this.mode,
      createTechnicalDetails: this.createTechnicalDetails
    });
    return parameterJsonString;
  }

  public parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.mode = parsed.mode;
      this.createTechnicalDetails = parsed.createTechnicalDetails;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
